module.exports = __webpack_public_path__ + "darkimg-deploymentprocess.35da2d2e9d93cdf5af2d54b4d275d95a.hashedasset.svg";